import React from 'react';
import { motion } from 'framer-motion';
import {
  SiLaravel,
  SiPhp,
  SiMysql,
  SiRedis,
  SiVuedotjs,
  SiLivewire,
  SiAmazonwebservices,
  SiDocker,
  SiGit,
} from 'react-icons/si';

const items = [
  { name: 'Laravel', icon: SiLaravel, color: 'text-red-600' },
  { name: 'PHP', icon: SiPhp, color: 'text-indigo-600' },
  { name: 'MySQL', icon: SiMysql, color: 'text-blue-700' },
  { name: 'Redis', icon: SiRedis, color: 'text-rose-600' },
  { name: 'Vue.js', icon: SiVuedotjs, color: 'text-emerald-600' },
  { name: 'Livewire', icon: SiLivewire, color: 'text-pink-600' },
  { name: 'AWS', icon: SiAmazonwebservices, color: 'text-amber-500' },
  { name: 'Docker', icon: SiDocker, color: 'text-sky-600' },
  { name: 'Git', icon: SiGit, color: 'text-orange-600' },
];

const TechStackV2 = () => {
  return (
    <section className="py-16 md:py-20 lg:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="w-full rounded-2xl bg-white border border-gray-200 p-6 md:p-8">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6 tracking-tight text-gray-900">Core Engineering Stack</h2>
        <div className="w-16 h-1 bg-blue-600 rounded mt-2 mb-6"></div>
        <p className="text-sm md:text-base text-gray-600 max-w-2xl mb-8">
          Technologies used to build robust, scalable, and production-ready backend systems.
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 md:gap-8">
          {items.map((item, i) => {
            const Icon = item.icon;
            return (
            <motion.div
              key={item.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.03, y: -4 }}
              className="rounded-xl border border-gray-200 bg-gray-50 p-6 md:p-8 shadow-md hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex flex-col items-center gap-3 text-center">
                <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center shadow-sm">
                  <Icon className={`text-xl ${item.color}`} />
                </div>
                <p className="text-lg md:text-xl font-semibold text-gray-800">{item.name}</p>
              </div>
            </motion.div>
            );
          })}
        </div>
      </div>
      </div>
    </section>
  );
};

export default TechStackV2;
